// MyCodingTeam.jsx
import React, { useState } from 'react';
import MainLayout from '../../layouts/MainLayout';
import { Link } from 'react-router-dom';
import './MyCodingTeam.css';

const MyCodingTeam = () => {
  const [jsxCode, setJsxCode] = useState('');
  const [cssCode, setCssCode] = useState('');

  const generateJsxCode = () => {
    try {
        const specTextareaValue = document.getElementById('specTextarea').value.trim();
        const specs = JSON.parse(specTextareaValue);
                
        let jsxCodeString1 = '';
        jsxCodeString1 += `// MySampleCode.jsx\n`;
        jsxCodeString1 += `import React from 'react';\n`;
        jsxCodeString1 += `import { Link } from 'react-router-dom';\n`;
        jsxCodeString1 += `import MainLayout from '../../layouts/MainLayout';\n`;
        jsxCodeString1 += `import './MySampleCode.css'; \n\n`;
        jsxCodeString1 += `const MySampleCode = () => {\n`;
        jsxCodeString1 += `    const myFunction = () => {\n`;
        jsxCodeString1 += `        console.log("Button clicked!");\n`;
        jsxCodeString1 += `    };\n`;
        jsxCodeString1 += `    return (\n`;
        jsxCodeString1 += `        <MainLayout>\n`;
        jsxCodeString1 += `            <div className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>\n`;
        jsxCodeString1 += `                <div className="dashboard-header">\n`;
        jsxCodeString1 += `                    <h3>My Junior Developer</h3>\n`;
        jsxCodeString1 += `                </div>\n`;
        jsxCodeString1 += `            </div>\n`;
        jsxCodeString1 += `            <div className="sample-container">\n`;

        let jsxCodeString2 = '';
        specs.forEach(spec => {
            switch (spec.Element) {
                case 'label':
                    jsxCodeString2 += `                <label className="label" htmlFor="${spec['for/id']}">${spec.value}</label>\n`;
                    break;
                case 'input':
                case 'textarea':
                case 'select':
                    jsxCodeString2 += `                <${spec.Element} ${spec['for/id'] ? 'id' : 'for'}="${spec['for/id']}" name="${spec.name}" value="${spec.value}" className="${spec.Element === 'input' ? 'input-field' : spec.Element === 'textarea' ? 'text-area' : 'drop-down'}" />\n`;
                    break;
                case 'radio':
                case 'checkbox':
                    jsxCodeString2 += `                <input type="${spec.Element}" id="${spec['for/id']}" name="${spec.name}" value="${spec.value}" />\n`;
                    jsxCodeString2 += `                <label htmlFor="${spec['for/id']}">${spec.value}</label>\n`;
                    break;
                case 'button':
                    jsxCodeString2 += `                <button type="${spec.type}" className="button" onClick={myFunction}>${spec.value}</button>\n`;
                    break;
                default:
                    break;
            }
        });

        jsxCodeString2 += `            </div>\n`;
        jsxCodeString2 += `        </MainLayout>\n`;
        jsxCodeString2 += `    );\n`;
        jsxCodeString2 += `};\n\n`;
        jsxCodeString2 += `export default MySampleCode;`;

        const jsxCodeString = jsxCodeString1 + jsxCodeString2;
        setJsxCode(jsxCodeString);
        generateCssCode(jsxCodeString);
    } catch (error) {
        console.error('Error generating JSX code:', error);
    }
};

const generateCssCode = (jsxCodeString) => {
  try {
      const regex = /id="([^"]+)"/g;
      let match;
      let cssCodeString = '';

      while ((match = regex.exec(jsxCodeString)) !== null) {
          const id = match[1];
          cssCodeString += `#${id} {\n`;
          cssCodeString += `  /* Add your CSS styles here */\n`;
          cssCodeString += `}\n\n`;
      }

      const cssFileNameComment = `// MySampleCode.css\n`;
      cssCodeString = cssFileNameComment + cssCodeString;
      setCssCode(cssCodeString);
  } catch (error) {
      console.error('Error generating CSS code:', error);
  }
};

  return (
    <MainLayout>
      <div className='text-lg mt-1 mx-8 border-b border-b-gray-300 text-white'>
        <div className="dashboard-header">
          <h3>My Junior Developer</h3>
        </div>
      </div>
      <div className="container">
      <div>
        <textarea id="specTextarea" placeholder="Enter specifications here..."></textarea>
        <button id="generateBtn" onClick={generateJsxCode}>Generate JSX Code</button>
        <textarea id="outputTextarea" value={jsxCode} placeholder="Generated JSX code will appear here..."></textarea>
        <textarea id="cssOutputTextarea" value={cssCode} placeholder="Generated CSS code will appear here..."></textarea>
      </div>
      <div>
        <Link to="/my-code-generator-output" className="link-button">
          <h2>Check The Code Output</h2>
        </Link>
      </div>
      </div>
    </MainLayout>
  );
};

export default MyCodingTeam;

